import type { IAccountBalance } from "../hooks/api/mm/useAccountBalanceHistory";

// Explicit perp topology: an account missing for the entire window must still
// invalidate the snapshot. Other books retain their observed account topology.
export const EXPECTED_PERP_EQUITY_ACCOUNTS = [
  "AEVO/perp_1", "AEVO/perp_2", "BINANCE/binance_aevo", "BYBIT/bybit_aevo",
  "HYPERLIQUID/hl_aevo", "HYPERLIQUID/hl_equity",
  "LIGHTER/lighter_aevo", "LIGHTER_MAINNET/lighter_mainnet_aevo",
];
const accountKey = (row: IAccountBalance) => `${row.Exchange}/${row.AccountName}`;

export function equityCoverage(rows: IAccountBalance[], now = Date.now()) {
  const expected = new Map<string, Set<string>>([["perp", new Set(EXPECTED_PERP_EQUITY_ACCOUNTS)]]);
  const groups = new Map<string, IAccountBalance[]>();
  const latest = new Map<string, number>();
  rows.forEach((row) => {
    if (!expected.has(row.Strategy)) expected.set(row.Strategy, new Set());
    expected.get(row.Strategy)!.add(accountKey(row));
    const key = `${row.Strategy}:${row.Timestamp}`;
    groups.set(key, [...(groups.get(key) ?? []), row]);
    latest.set(row.Strategy, Math.max(latest.get(row.Strategy) ?? 0, Number(row.Timestamp)));
  });
  const data: IAccountBalance[] = [];
  const latestComplete = new Set<string>();
  groups.forEach((group) => {
    const strategy = group[0].Strategy;
    const accounts = new Set(group.map(accountKey));
    const complete = accounts.size === group.length &&
      Array.from(expected.get(strategy)!).every((account) => accounts.has(account)) &&
      group.every((row) => row.USDBalance !== "" && Number.isFinite(Number(row.USDBalance)));
    if (complete) {
      data.push(...group);
      if (Number(group[0].Timestamp) === latest.get(strategy)) latestComplete.add(strategy);
    }
  });
  const unavailable = Array.from(expected.keys()).filter((strategy) => {
    const age = now - (latest.get(strategy) ?? 0) / 1e6;
    return !latestComplete.has(strategy) || age < 0 || age > 600_000;
  });
  return { data, unavailable };
}
